import App from '../services/App/App';
import {IApp} from '../@interfaces/services/App';
import {IContainedServices} from '../@interfaces/services/Container/IContainedServices';

let instance: IApp;

export function app(serviceName?: undefined): IApp;
export function app<K extends keyof IContainedServices>(serviceName: K): IContainedServices[K];
export function app<K extends keyof IContainedServices>(serviceName?: K): IApp | IContainedServices[K] {
	if (!serviceName) {
		return instance || (instance = new App());
	}

	const service = app().make<IContainedServices[K]>(serviceName);
	if (!service) {
		throw new Error(`Service [${serviceName}] not found`);
	}

	return service;
}

export default app;
